import TableInterestBars from "./TableInterestBars";
export default TableInterestBars;
